import { axiosClient, chatBot, ENDPOINTS } from "../../../services/common";
import { createAsyncThunk } from "@reduxjs/toolkit";

// seller product channels before login api
export const getChannelsBeforeLogin = createAsyncThunk(
  "product-channels-list-before-login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.PRODUCT_CHANNELS_BEFORE_LOGIN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while getting a product types.",
      );
    }
  },
);

// common download of insertion order
export const downloadInsertionOrder = createAsyncThunk(
  "download-insertion-order",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.DOWNLOAD_INSERTION_ORDER}/${id}`,
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while download insertion order.",
      );
    }
  },
);

// Download Insertion Order (IO) with Sign when campaign is in insertion order
export const downloadIOWithSign = createAsyncThunk(
  "download-io-with-sign",
  async (envelopeId, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.DOWNLOAD_SIGNED_IO + `/${envelopeId}`,
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || " An error occured while downloading signed IO",
      );
    }
  },
);

// get single product details api
export const getSingleProductDetails = createAsyncThunk(
  "get-single-product-details",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.GET_SINGLE_PRODUCT_DETAILS}/${id}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while download insertion order.",
      );
    }
  },
);

// get single product details api before login
export const getSingleProductDetailsBeforeLogin = createAsyncThunk(
  "get-products-details-before-login",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.GET_SINGLE_PRODUCT_DETAILS_BEFORE_LOGIN}/${id}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while download insertion order.",
      );
    }
  },
);

// common download of quote
export const downloadQuote = createAsyncThunk(
  "download-quote",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.DOWNLOAD_QUOTE}/${id}`,
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while download quote.",
      );
    }
  },
);

// IO save user details
export const saveUserDetails = createAsyncThunk(
  "save-user-details",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.SAVE_USER_DETAILS,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login.",
      );
    }
  },
);

//Get the Profile Details
export const getUserProfile = createAsyncThunk(
  "user-information",
  async (mongo_id, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.BUYER_PROFILE);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while viewing user details",
      );
    }
  },
);

//Post profile Details
export const postUserProfile = createAsyncThunk(
  "user-details",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_PROFILE_UPDATE,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while updating the user details.",
      );
    }
  },
);
//Post User Password change
export const postChangePassword = createAsyncThunk(
  "user-password-change",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.CHANGE_PASSWORD,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while changing the password .",
      );
    }
  },
);
//Delete Profile Photo
export const deleteUserProfile = createAsyncThunk(
  "user-photo-delete",
  async (payload, { rejectWithValue }) => {
    try {
      const { mongo_id } = payload;
      const response = await axiosClient.post(
        `${ENDPOINTS.BUYER_PROFILE_DELETE}/${mongo_id}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while deleting the profile photo.",
      );
    }
  },
);
//Submit RFP Form Without Login
export const postSubmitRFP = createAsyncThunk(
  "submit-rfp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.SUBMIT_RFP_FORM,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while submitted  the RFP details.",
      );
    }
  },
);

//Submit RFP Form Without Login
export const postSubmitRFPWithLogin = createAsyncThunk(
  "submit-rfp-with-login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.SUBMIT_RFP_FORM_WITH_LOGIN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while submitted  the RFP details.",
      );
    }
  },
);
//Advertisement Type
export const getAdvertisementType = createAsyncThunk(
  "get-ad-positions",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.ADVERTISEMENT_WITH_AMP_TARGET_AUDIENCE,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred during getting the positions.",
      );
    }
  },
);

// Advertisement with AMP Post
export const advWithAmpPost = createAsyncThunk(
  "advertiseWithAMP",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.ADVERTISEMENT_WITH_AMP_POST,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while submitted  the Advertisement With AMP details.",
      );
    }
  },
);

// Billing Enquiry
export const userQueryPost = createAsyncThunk(
  "request-query",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.USER_QUERY_POST,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while requesting the user Query.",
      );
    }
  },
);
//Get User Pricing Modules

export const getUserPricingModules = createAsyncThunk(
  "get-pricing",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.GET_USER_PRICING_MODULES,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred during getting the pricing modules.",
      );
    }
  },
);
//Get Default Payment Terms
export const getDefaultPaymentTerms = createAsyncThunk(
  "get-default-terms",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.DEFAULT_PAYMENT_TERMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred during getting the pricing modules.",
      );
    }
  },
);

//Price prediction
export const getPricePredictionOfProducts = createAsyncThunk(
  "get-price-prediction-products",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.PRODUCTS_PRICE_PREDICTION,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while sending a productslist request.",
      );
    }
  },
);

// Chatbot
export const fetchChatBotResponse = createAsyncThunk(
  "chatBotAIAssistant",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await chatBot.post("/chat", payload, {});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while requesting the user Query.",
      );
    }
  },
);

// Fetching Notifications
export const getNotifications = createAsyncThunk(
  "seller-buyer-notifications",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.NOTIFICATIONS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while fetching the user notifications",
      );
    }
  },
);

// Marking Unread Notifications as Read
export const updateNotifications = createAsyncThunk(
  "update-notifications",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.UPDATE_NOTIFICATIONS,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data ||
        "An error occurred while marking the user notifications as read",
      );
    }
  },
);

export const getFilterProducts = createAsyncThunk(
  "filters-product",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.FILTERS_PRODUCTS,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred while requesting the user Query.",
      );
    }
  },
);

// Fetching ads to display
export const getAds = createAsyncThunk(
  "get-ads",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.GET_AD_DETAILS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occured while fecthing ads.",
      );
    }
  },
);

export const getChatHistory = createAsyncThunk(
  "chat-communication-history",
  async ({ campaignId, bookingId }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.CHAT_COMMUNICATION_HISTORY + `/${campaignId}/${bookingId}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occured while fecthing ads.",
      );
    }
  },
);

// Chat bot new schema api
export const getChatBotNewSchema = createAsyncThunk(
  "chat-bot-schema",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.GET_CHATBOT_SCHEMA,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "Sorry, something went wrong. Please try again in a moment.",
      );
    }
  },
);

//update all negotiation terms status
export const updateAllNegotiationTerms = createAsyncThunk(
  "negotiationTerms",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.UPDATE_NEGOTIATION_TERMS_STATUS,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while requesting the terms.",
      );
    }
  },
);


export const varibaleChargeRate = createAsyncThunk(
  "variable-charge-rate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.VARIABLE_CHARGE_RATES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        "An error occurred during getting the variable charge rates.",
      );
    }
  },
);
export const getDownloadSigned = createAsyncThunk(
  "download-signed",
  async ({ envelope_id }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.GET_DOWNLOAD_SIGNED}/${envelope_id}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(response.data);

      const link = document.createElement("a");
      link.href = url;
      link.download = "signed-document.pdf";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error("Download error:", error);

      return rejectWithValue(
        error.response?.data ||
        "An error occurred while downloading the signed document."
      );
    }
  }
);